const MEDIA_WIDTH = {
  XL: '1920px',
  LG: '1280px',
  MD: '960px',
  SM: '600px',
  XS: '0px',
} as const;

export const MAX_MOBILE_SCREEN_SIZE = 768;

export const MEDIA_WIDTH_MD = MEDIA_WIDTH.MD;
